module.exports = __webpack_public_path__ + "static/media/LowBatteryMarker.60df53e8.svg";